import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/notices")({
    validateSearch: (search) => ({
        notice: typeof search.notice === "string" ? search.notice : undefined,
    }),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: "/feed",
            search: { post: search.notice },
            replace: true,
        });
    },
});
